export default __webpack_public_path__ + "static/media/re.626bffce.png";